import { Amount } from 'ib/internetbank-core/ib-models/amount';
import { ImageDataDesign } from 'ib/internetbank-core/ib-models/image-data-design';
import { ISODateString } from 'ib/internetbank-core/utils/date-utils';

export interface InsuranceSportForm {
	client: InsuranceSportPersonalInfo;
	image: ImageDataDesign;
	insuranceId: number;
	insuranceInfoPdfUrl: string;
	insuranceName: string;
	insuranceRisks: Array<string>;
	insuranceSums: Array<Amount>;
	sportTypes: Array<InsuranceSportTypes>;
	email: string;
	sportInsuranceInfoDocumentLink?: string;
}

export interface InsuranceSportTypes {
	id: number;
	name: string;
}

export interface InsuranceSportPremiumSum extends InsuanceSportPeriod {
	sportTypeIds: Array<number>;
	insuranceSum: number;
	numberOfAdults?: number;
	numberOfChildren?: number;
	annual: boolean | number;
	durationId: 1 | 2;
	birthDates?: Array<ISODateString>;
}

export interface InsuranceSportCreateData extends InsuranceSportPremiumSum {
	insuranceId: number;
	insuredPersons: Array<InsuranceSportPersonalInfo>;
	premiumSum: number;
	email: string;
	isSportInsuranceDocumentAgree: boolean;
	contractId: number;
}

export interface InsuranceSportPersonalInfo {
	surname: string;
	name: string;
	patronymic: string;
	birthdate: ISODateString;
}

export interface InsuranceSportAutocompletePersonalData extends InsuranceSportPersonalInfo {
	email: string;
}

export interface InsuranceSportConfirmDoneData extends InsuanceSportPeriod {
	operationTime: ISODateString;
	sourceAccountNumber: string;
	beneficiaryAccountNumber: string;
	beneficiaryBankName: string;
	insuredPersons: Array<{
		fio: string;
		birthDate: ISODateString;
	}>;
	insuredSports: Array<string>;
	clientEmail: string;
	insuranceSum: Amount;
	premiumSum: Amount;
	insuranceRisks: Array<string>;
}

export interface InsuanceSportPeriod {
	beginDate: ISODateString;
	endDate: ISODateString;
}

export enum InsuranceSportDescriptionErrorCode {

	INSURANCE_AGREEMENT_ALREADY_EXISTS = 'Застрахованный уже участвует в&nbsp;договоре страхования. Измените список застрахованных лиц или даты страхования. Повторите заявку снова!',
	WRONG_INSURED_PERSON_AGE = 'Возраст застрахованных лиц&nbsp;&mdash; от&nbsp;2&nbsp;до&nbsp;65&nbsp;лет',
}

export const MAX_LIMIT_INSURED = 12;

export const MIN_LIMIT_DAYS_FOR_ROUND_THE_CLOCK_POLICY = 4;
